export var generateUUIDV4 = function generateUUIDV4(customCrypto) {
  if (customCrypto === void 0) {
    customCrypto = typeof window !== 'undefined' ? window.crypto : undefined;
  }

  if (!customCrypto) return '';
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c => {
    var _customCrypto;

    return (c ^ ((_customCrypto = customCrypto) == null ? void 0 : _customCrypto.getRandomValues(new Uint8Array(1))[0]) & 15 >> c / 4).toString(16);
  });
};
//# sourceMappingURL=uuid.js.map